import React from 'react';
import './CustomStepper.css';
import { useMediaQuery } from 'react-responsive';

import { Tooltip } from 'primereact/tooltip';


const CustomStepper = ({ totalSteps, activeStep, completedSteps, onStepClick, stepTitles }) => {

const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <div className="custom-stepper" style={{ display: 'flex', alignItems: 'center' }}>
      {[...Array(totalSteps)].map((_, index) => {
        const isActive = index === activeStep;
        const isComplete = completedSteps.includes(index);
        const title = stepTitles?.[index] || `Etapa ${index + 1}`;

        return (
          <div
            key={index}
            className="p-stepper-panel"
            style={{ display: 'flex', alignItems: 'center', position: 'relative', cursor: 'pointer' }}
            onClick={() => onStepClick?.(index)}
          >
            {!isMobile && (<Tooltip target={`#step-circle-${index}`} content={title} position="top" />) }
            <div
              id={`step-circle-${index}`}
              className={`p-stepper-header ${isActive ? 'p-highlight' : ''} ${isComplete && !isActive ? 'p-complete' : ''}`}
              style={{ zIndex: 1 }}
            >
              <div className="p-stepper-number">
                {isComplete && !isActive ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M9.57801 15.642L19.22 6L20.5003 7.28025L9.57801 18.2025L4.49976 13.1257L5.78001 11.8455L9.57801 15.642Z" fill="white"/>
                  </svg>
                ) : String(index + 1).padStart(2, '0')}
              </div>
            </div>
          </div>          
        );
      })}
    </div>
  );
};

export default CustomStepper; // ✅ isso aqui é ESSENCIAL
